import { defineMessages } from 'react-intl';

export default defineMessages({
    tabletAccordionTitle: {
        id: 'pe-portal.wizard.components.WMICWizardSidebar.tabletAccordionTitle',
        defaultMessage: 'Page {currentStep} of {totalSteps} : {pageTitle}',
    },
});
